module.exports = __webpack_public_path__ + "media/waves2560.1eb355f2.mp4";